// The shared number formatters. Money first: Stripe amounts are integer
// cents, the office spreadsheet carries dollars - separate entry points
// keep the unit visible at every call site, so a stray /100 cannot pass
// review. fmtNum is the plain thousands-separated count.

export function fmtCents(cents: number): string {
  return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function fmtDollars(dollars: number): string {
  return dollars.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function fmtNum(n: number): string {
  return n.toLocaleString("en-US");
}
